<script setup></script>

<template>
  <svg width="48" height="32" viewBox="0 0 48 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="48" height="32" rx="4" fill="white" />
    <path
      d="M17.9754 26C23.4847 26 27.9509 21.5228 27.9509 16C27.9509 10.4772 23.4847 6 17.9754 6C12.4662 6 8 10.4772 8 16C8 21.5228 12.4662 26 17.9754 26Z"
      fill="#EB001B"
    />
    <path
      d="M30.0262 26C35.5355 26 40.0017 21.5228 40.0017 16C40.0017 10.4772 35.5355 6 30.0262 6C24.5169 6 20.0508 10.4772 20.0508 16C20.0508 21.5228 24.5169 26 30.0262 26Z"
      fill="#F79E1B"
    />
    <path
      d="M23.9992 8.01398C26.4011 9.8385 27.9476 12.7298 27.9476 15.9801C27.9476 19.2303 26.4011 22.1266 23.9992 23.9512C21.5973 22.1266 20.0508 19.2353 20.0508 15.9801C20.0508 12.7248 21.6023 9.8385 23.9992 8.01398Z"
      fill="#FF5F00"
    />
  </svg>
</template>
